// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__395s6","col":"styles_col__2Nxnw","fulfillmentStatus":"styles_fulfillmentStatus__2AUcF","emailCol":"styles_emailCol__Qrv3j"};